export enum ScoreCategory {
	Engagement = 'engagement',
	Targets = 'targets',
	Feedback = 'feedback',
	OneOnOne = 'oneOnOne',
	Conversations = 'conversations',
}

export type TreamsCategoryScore = {
	score: number;
	delta: number;
};

export type TreamsScore = Record<ScoreCategory, TreamsCategoryScore> & {
	total: TreamsCategoryScore;
};

export type TreamsScoreRow = {
	id: string;
	name: string;
	type: string;
	people: number;
	managers: { id: string; firstName: string; lastName: string }[];
	scores: TreamsScore;
};

export interface ScoreAnalytics {
	scores: TreamsScore;
	rows: TreamsScoreRow[];
	// True when a qualifying engagement survey ran inside the scoring window
	// ending at the selected end-date.
	engagementSurveyAvailable: boolean;
	// Oldest qualifying engagement survey ever sent; drives the ramp-up
	// warning on the engagement factor. Null when no survey ran yet.
	engagementFirstSurveyAt: Date | null;
}

// Calculated scores are never negative, so -1 marks a row whose calculation
// threw: it stays in the table as failed instead of silently disappearing.
export const FAILED_SCORE = -1;

export const isFailedScore = (score: number): boolean => score < 0;

export const failedTreamsScore = (): TreamsScore => ({
	total: { score: FAILED_SCORE, delta: 0 },
	[ScoreCategory.Engagement]: { score: FAILED_SCORE, delta: 0 },
	[ScoreCategory.Targets]: { score: FAILED_SCORE, delta: 0 },
	[ScoreCategory.Feedback]: { score: FAILED_SCORE, delta: 0 },
	[ScoreCategory.OneOnOne]: { score: FAILED_SCORE, delta: 0 },
	[ScoreCategory.Conversations]: { score: FAILED_SCORE, delta: 0 },
});
